// Packages
import { Component } from "react";
import moment from "moment";
// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
// Styles
import "./superAdmin.css";

import "bootstrap/dist/css/bootstrap.css";

// Services
import userService from "../../services/user.service";
import { withRouter } from "react-router-dom";
import PaymentHistoryTable from "../../Common/PaymentHistoryTable";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import ContentLayoutDetailsHeader from "../../Common/ContentLayoutDetailsHeader";
import { ContentLayoutSpinner } from "../spinner/ContentLayoutSpinner";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import { openSuccessPopup } from "../../Redux/Actions/PopupActions";

class paymentSchoolDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schoolId: this.props?.match?.params?.schoolId,
      billingDetailsResponses: [],
      deleteId: "",
      openDeletePop: false,
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      recordNotFound: false,
      searchQuery: "",
      btnText: "",
      successPopup: false,
      msg: "",
      redirectToRow: false,
      currentRowId: "",
      searchedRecord: false,
      userRole: this.props.userRole,
      submitting: false,
      loginRole: getFromLocalStorage("loginRole"),
    };
  }

  componentDidMount() {
    const payment = document.getElementById("Payments");
    const { pageState, schoolId } = this.state;
    if (payment) {
      payment.classList.add("active");
    }
    this.getAllBillingDetails(schoolId);
    this.setState({ submitting: true });
    this.getBillingDetailsByPage(pageState.page, pageState.pageSize);
  }

  editPaymentApiCall = (data) => {
    const { pageState, searchQuery, searchedRecord } = this.state;
    var amount = data.amount.slice(1);
    var id = data.id;
    var note = data.note;
    var paymentMethod = data.paymentMethod;
    var paymentStatus = "Overdue";
    var schoolId = data.schoolId;
    var uploadFilesInvoiceId = data.uploadFiles.id;
    var validityDate = moment(data.validityDate).format("YYYY-MM-DD");
    userService
      .editPayments(
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate
      )
      .then((response) => {
        if (searchedRecord) {
          this.searchPayment(searchQuery, pageState.page, 10);
        } else {
          this.getBillingDetailsByPage(pageState.page, 10);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  editPaymentApiCallPaid = (data) => {
    const { pageState, searchedRecord, searchQuery } = this.state;
    var amount = data.amount.slice(1);
    var id = data.id;
    var note = data.note;
    var paymentMethod = data.paymentMethod;
    var paymentStatus = "Paid";
    var schoolId = data.schoolId;
    var uploadFilesInvoiceId = data.uploadFiles.id;
    var validityDate = moment(data.validityDate).format("YYYY-MM-DD");
    userService
      .editPayments(
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate
      )
      .then((response) => {
        if (searchedRecord) {
          this.searchPayment(searchQuery, pageState.page, 10);
        } else {
          this.getBillingDetailsByPage(pageState.page, 10);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  editPaymentApiCallPending(data) {
    var amount = data.amount.slice(1);
    var id = data.id;
    var note = data.note;
    var paymentMethod = data.paymentMethod;
    var paymentStatus = "Pending";
    var schoolId = data.schoolId;
    var uploadFilesInvoiceId = data.uploadFiles.id;
    var validityDate = moment(data.validityDate).format("YYYY-MM-DD");
    userService
      .editPayments(
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate
      )
      .then((response) => {
        this.getAllBillingDetails(this.state.schoolId);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getAllBillingDetails(schoolId) {
    this.setState({ submitting: true });
    userService
      .getSchoolBillingDetails(schoolId)
      .then((response) => {
        var billingDetailsResponses =
          response.data.data.billingDetailsResponses;
        var schoolname =
          response.data.data.billingDetailsResponses[0].schoolName;
        this.setState({
          billingDetailsResponses,
          schoolname,
          submitting: false,
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.setState({ submitting: false });
      });
  }

  getBillingDetailsByPage = (page, size) => {
    const { schoolId, recordNotFound, pageState } = this.state;
    this.setState({
      pageState: { ...pageState, isLoading: true },
    });
    userService
      .getSchoolBillingDetailsByPage(schoolId, page, size)
      .then((res) => {
        const data = res.data.data;
        this.setState({
          pageState: {
            ...pageState,
            data: data.billingDetailsResponses,
            isLoading: false,
            total: data.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: { ...pageState, isLoading: true },
          submitting: false,
        });
      });
  };

  openInNewTab = (url) => {
    var newWindow = window.open(
      url.uploadFiles.filePath,
      "_blank",
      "noopener,noreferrer"
    );
    if (newWindow) newWindow.opener = null;
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  searchPayment = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchPayment(query, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.billingDetailsResponses,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound:
            res.data.data.billingDetailsResponses.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  render() {
    const { schoolname, submitting, loginRole } = this.state;

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div className="content-layout add-sectionn p-history position-relative">
            <SuperAdminDashboard />
            <ContentLayoutSpinner animate={submitting} />
            <ContentLayoutDetailsHeader
              label="Payment History"
              name={schoolname}
              navigationLink="/payment"
              iconList={[]}
            />
            <div className="">
              <Container>
                <PaymentHistoryTable />
              </Container>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopup: (obj) => openSuccessPopup(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(paymentSchoolDetails)
);
